<template>
  <BasicPagination
    :current-page="pagesNumber"
    :nb-pages="pagesCount"
    :nb-pages-max="10"
    :nb-results="habilitations?.length ?? 0"
    @change="(value: number) => (pagesNumber = value)"
  />
  <!-- DESKTOP -->
  <div class="rattachements--desktop">
    <!-- Header Desktop -->
    <div class="cardLayoutWrapper cardLayoutWrapper--header">
      <!-- type administrateur -->
      <template v-if="engineState.type === 'administrateur'">
        <div
          class="elem"
          :class="desktopColumnSizeClass.compte"
        >
          <span v-if="engineState.mode === 'contact'">Compte</span>
          <div
            v-else
            class="elem flex-1"
          >
            <div class="flex-1">
              <span>Utilisateur</span>
            </div>
            <div class="flex-1">
              <span>Compte</span>
            </div>
          </div>
        </div>
      </template>
      <!-- type utilisateur -->
      <div
        v-else
        class="elem"
        :class="desktopColumnSizeClass.compte"
      >
        <span>Compte</span>
      </div>
      <div
        class="elem"
        :class="desktopColumnSizeClass.permission"
      >
        <span>Permissions</span>
      </div>
      <div
        class="elem"
        :class="desktopColumnSizeClass.typePublic"
      >
        <span>Type de public</span>
      </div>
      <div
        class="elem"
        :class="desktopColumnSizeClass.admin"
      >
        <span>Admin</span>
      </div>
      <div
        class="elem"
        :class="desktopColumnSizeClass.action"
      ></div>
    </div>
    <!-- Ligne Desktop -->
    <div
      class="gridElemWrapper"
      v-for="(item, index) in pageData"
      :key="index"
    >
      <!-- Description -->
      <div class="cardLayoutWrapper">
        <div
          class="elem"
          :class="desktopColumnSizeClass.compte"
        >
          <div
            v-if="
              item.estHabilitation &&
              engineState.type === 'administrateur' &&
              ['entite', 'habilitations'].includes(engineState.mode ?? '')
            "
            class="card__top flex-1"
          >
            <BasicIcon name="profile" />
            <div
              class="card__top__text"
              v-if="item.userNomPrenom"
            >
              <BasicLink
                v-if="item.navigateToUserAllowed"
                :label="item.userNomPrenom"
                @link-click="item.navigateToUser"
                size="small"
                type="dark"
              />
              <span v-else>{{ item.userNomPrenom }}</span>
              <span class="sous-titre">{{ item.userEmail }}</span>
            </div>
            <div
              class="card__top__text"
              v-else
            >
              <span>{{ item.userId }}</span>
              <span class="sous-titre">Utilisateur inconnu</span>
            </div>
          </div>
          <div class="card__top flex-1">
            <BasicIcon name="building" />
            <div class="card__top__text">
              <BasicLink
                v-if="item.navigateToEntiteAllowed"
                :label="item.entiteDenomination"
                @link-click="item.navigateToEntite"
                size="small"
                type="dark"
              />
              <span v-else>{{ item.entiteDenomination }}</span>
              <span class="sous-titre">{{ item.entiteSirenOuSiret }}</span>
            </div>
          </div>
        </div>
        <template v-if="item.type === 'habilitation'">
          <div
            class="elem"
            :class="desktopColumnSizeClass.permission"
          >
            <div class="card">
              <div class="card__top">
                <BasicIcon name="edit" />
                <div class="card__top__text">
                  <span
                    class="sous-titre clickable"
                    @click="showPermissionItem = item"
                  >
                    <template v-if="item.permissionsEcriture.length > 0">
                      {{ item.permissionsEcriture.join(', ') }}
                    </template>
                    <template v-else>Aucune</template>
                  </span>
                </div>
              </div>
              <div class="card__top">
                <BasicIcon name="eye" />
                <div class="card__top__text">
                  <span
                    class="sous-titre clickable"
                    @click="showPermissionItem = item"
                  >
                    <template v-if="item.permissionsLecture.length > 0">
                      {{ item.permissionsLecture.join(', ') }}
                    </template>
                    <template v-else>Aucune</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elem"
            :class="desktopColumnSizeClass.typePublic"
          >
            <div class="card__top__text">
              <span>{{ item.typesPublicsLibelle }}</span>
            </div>
          </div>
          <div
            class="elem"
            :class="desktopColumnSizeClass.admin"
          >
            <div class="card__top__text">
              <span v-if="item.estAdministrateur">Oui</span>
              <span v-else>Non</span>
            </div>
          </div>
          <div
            class="elem justify-content-end"
            :class="desktopColumnSizeClass.action"
          >
            <div class="card__top">
              <BasicButton
                :icon-name="drawerId === index ? 'arrow-up' : 'arrow-down'"
                :icon-right="true"
                :label="drawerId === index ? 'Fermer' : isReadOnly ? 'Voir' : 'Modifier'"
                @click="toggleDrawer(index)"
                style="min-width: 100px"
              />
            </div>
          </div>
        </template>
        <template v-else-if="item.type === 'visiteur'">
          <div
            class="elem"
            :class="desktopColumnSizeClass.validationSeparateur"
          ></div>
          <div
            class="elem justify-content-end"
            :class="desktopColumnSizeClass.validationAction"
          >
            <BasicButton
              label="Autoriser"
              icon-name="profile"
              :disabled="isReadOnly"
              @click="item.setActivation(true)"
            />
          </div>
          <div
            class="elem justify-content-end"
            :class="desktopColumnSizeClass.validationAction"
          >
            <BasicButton
              label="Refuser"
              icon-name="trash"
              type="danger"
              :disabled="isReadOnly"
              @click="item.setActivation(false)"
            />
          </div>
        </template>
        <template v-else>
          <div
            class="elem"
            :class="desktopColumnSizeClass.messageAttente"
          >
            <div class="card__top__text flex-1">
              <span>Demande de rattachement en attente</span>
              <basic-text weight="light">{{ item.ligne1 }}</basic-text>
              <basic-text
                weight="light"
                v-if="item.type === 'attente-courrier' && item.ligne2"
              >
                {{ item.ligne2 }}
              </basic-text>
            </div>
          </div>
        </template>
      </div>
      <!-- Panneau de modification -->
      <div
        class="bottomWrapper"
        v-if="drawerId === index && item.type === 'habilitation'"
      >
        <!-- Listes des permissions -->
        <div class="bottomWrapper__grid">
          <div
            v-for="permission in item.permissions"
            :key="permission.type"
            class="bottomWrapper__grid__elem"
          >
            <div class="bottomWrapper__grid__elem__text">
              <BasicText
                size="body-m"
                color="secondary-900"
              >
                {{ permission.libelle }}
              </BasicText>
              <BasicText
                size="body-m"
                weight="bold"
                color="secondary-900"
                v-if="permission.libelle !== permission.type"
              >
                ({{ permission.type }})
              </BasicText>
            </div>
            <BasicToggleSwitch
              v-if="permission.mode === 'OuiNon'"
              v-bind:model-value="permission.niveau"
              @update:model-value="permission.switchPermission?.call(null)"
              size="small"
              :items="NiveauxPermissionOuiNonItems"
              :readonly="permission.isReadOnly"
            />
            <BasicToggleSwitch
              v-else
              v-bind:model-value="permission.niveau"
              @update:model-value="permission.setPermission?.call(null, $event as NiveauPermission)"
              size="small"
              :items="NiveauxPermissionItems"
              :readonly="permission.isReadOnly"
            />
          </div>
        </div>
        <!-- Boutons TypePublic et Admin -->
        <div class="bottomWrapper__bottom">
          <div class="bottomWrapper__bottom__leftContent">
            <!-- TypePublic -->
            <WrapperDropdown
              v-if="item.typesPublicsAvecPlusieursPotentiel"
              label="Type de public"
              :model-value="item.typesPublicsDropdownValue"
              @update:model-value="item.typesPublicsDropdownValueUpdate($event as TypePublicDropdownItem)"
              :items="item.typesPublicsDropdownItems"
              key-id="id"
              key-label="label"
              :readonly="isReadOnly"
              :deletable="false"
            ></WrapperDropdown>
            <!-- Admin -->
            <WrapperDropdown
              :label="`Administrateur ${item.estProprietaireHabilitation ? '(non modifiable)' : ''}`"
              :items="NiveauxPermissionOuiNonItems"
              :model-value="item.permissionAdministrateur.niveau"
              @update:model-value="item.permissionAdministrateur.switchPermission"
              :readonly="isReadOnly"
              :disabled="item.estProprietaireHabilitation"
              :deletable="false"
            ></WrapperDropdown>
          </div>
          <BasicButton
            v-if="!isReadOnly"
            label="Supprimer"
            :disabled="item.estProprietaireHabilitation"
            icon-name="trash"
            @click="item.deleteHabilitation"
          ></BasicButton>
        </div>
      </div>
    </div>
  </div>

  <!-- MOBILE -->
  <div class="rattachements--mobile">
    <div
      class="card"
      v-for="(item, index) in pageData"
      :key="index"
    >
      <!-- Utilisateur et Entite -->
      <div class="card__top card__top--mobile">
        <!-- Utilisateur -->
        <div
          v-if="
            item.estHabilitation &&
            engineState.type === 'administrateur' &&
            ['entite', 'habilitations'].includes(engineState.mode ?? '')
          "
          class="card__top__mobileElem"
        >
          <div class="card__top__mobileElem__title">
            <BasicIcon name="profile" />
            <div class="card__top__text">
              <span>Utilisateur</span>
            </div>
          </div>
          <div
            class="card__top__mobileElem__content"
            v-if="item.userNomPrenom"
          >
            <BasicLink
              v-if="item.navigateToUserAllowed"
              :label="item.userNomPrenom"
              @link-click="item.navigateToUser"
              size="small"
              type="dark"
            />
            <span v-else>{{ item.userNomPrenom }}</span>
            <span>{{ item.userEmail }}</span>
          </div>
          <div
            class="card__top__mobileElem__content"
            v-else
          >
            <span>{{ item.userId }}</span>
            <span>Utilisateur inconnu</span>
          </div>
        </div>
        <!-- Entite -->
        <div class="card__top__mobileElem">
          <div class="card__top__mobileElem__title">
            <BasicIcon name="building" />
            <div class="card__top__text">
              <span>Compte</span>
            </div>
          </div>
          <div class="card__top__mobileElem__content">
            <BasicLink
              v-if="item.navigateToEntiteAllowed"
              :label="item.entiteDenomination"
              @link-click="item.navigateToEntite"
              size="small"
              type="dark"
            />
            <span v-else>{{ item.entiteDenomination }}</span>
            <span>{{ item.entiteSirenOuSiret }}</span>
          </div>
        </div>

        <!-- space filler -->
        <div
          class="card__top__mobileElem"
          v-if="engineState.type !== 'administrateur' || engineState.mode === 'contact'"
        ></div>
        <template v-if="item.type === 'habilitation'">
          <div class="card__top__mobileElem">
            <div class="card__top__mobileElem__title">
              <div class="card__top__text">
                <span>Type de public</span>
              </div>
            </div>
            <div class="card__top__mobileElem__content">
              <span>{{ item.typesPublicsLibelle }}</span>
            </div>
          </div>
          <div class="card__top__mobileElem">
            <div class="card__top__mobileElem__title">
              <div class="card__top__text">
                <span>Admin</span>
              </div>
            </div>
            <div class="card__top__mobileElem__content">
              <span v-if="item.estAdministrateur">Oui</span>
              <span v-else>Non</span>
            </div>
          </div>
        </template>
      </div>
      <!-- Permissions modifier et consulter -->
      <div
        class="card__content card__content--mobile"
        v-if="item.type === 'habilitation'"
      >
        <span>Permissions</span>
        <div class="card__content--mobile__line">
          <BasicIcon name="edit" />
          <span
            class="clickable"
            @click="showPermissionItem = item"
          >
            <template v-if="item.permissionsEcriture.length > 0">
              {{ item.permissionsEcriture.join(', ') }}
            </template>
            <template v-else>Aucune</template>
          </span>
        </div>
        <div class="card__content--mobile__line">
          <BasicIcon name="eye" />
          <span
            class="clickable"
            @click="showPermissionItem = item"
          >
            <template v-if="item.permissionsLecture.length > 0">
              {{ item.permissionsLecture.join(', ') }}
            </template>
            <template v-else>Aucune</template>
          </span>
        </div>
      </div>
      <!-- Confirmer rattachement -->
      <div
        v-else-if="item.type === 'visiteur'"
        class="card__content card__content--mobile card__content--centered"
      >
        <span>La demande de rattachement est en attente d'autorisation.</span>
        <div class="buttonWrap">
          <BasicButton
            label="Autoriser"
            icon-name="profile"
            :disabled="isReadOnly"
            @click="item.setActivation(true)"
          />
          <BasicButton
            label="Refuser"
            icon-name="trash"
            type="danger"
            :disabled="isReadOnly"
            @click="item.setActivation(false)"
          />
        </div>
      </div>
      <!-- Demande rattachement en attente -->
      <div
        v-else
        class="card__content card__content--mobile card__content--centered"
      >
        <span>Demande de rattachement en attente</span>
        <basic-text weight="light">{{ item.ligne1 }}</basic-text>
        <basic-text
          weight="light"
          v-if="item.type === 'attente-courrier' && item.ligne2"
          style="margin-top: -12px"
        >
          {{ item.ligne2 }}
        </basic-text>
      </div>
      <!-- Panneau de modification -->
      <div
        class="bottomWrapper bottomWrapper--mobile"
        v-if="drawerId === index && item.type === 'habilitation'"
      >
        <div class="bottomWrapper__grid bottomWrapper__grid--mobile">
          <!-- Listes des permissions -->
          <div
            class="bottomWrapper__grid__elem"
            v-for="permission in item.permissions"
            :key="permission.type"
          >
            <div class="bottomWrapper__grid__elem__text">
              <BasicText
                size="body-m"
                color="secondary-900"
              >
                {{ permission.libelle }}
              </BasicText>
              <BasicText
                size="body-m"
                weight="bold"
                color="secondary-900"
                v-if="permission.libelle !== permission.type"
              >
                ({{ permission.type }})
              </BasicText>
            </div>
            <BasicToggleSwitch
              v-if="permission.mode === 'OuiNon'"
              v-bind:model-value="permission.niveau"
              @update:model-value="permission.switchPermission?.call(null)"
              size="small"
              :items="NiveauxPermissionOuiNonItems"
              :readonly="permission.isReadOnly"
            />
            <BasicToggleSwitch
              v-else
              v-bind:model-value="permission.niveau"
              @update:model-value="permission.setPermission?.call(null, $event as NiveauPermission)"
              size="small"
              :items="NiveauxPermissionItems"
              :readonly="permission.isReadOnly"
            />
          </div>

          <!-- Boutons TypePublic et Admin -->
          <div class="bottomWrapper__bottom bottomWrapper__bottom--mobile">
            <div
              class="bottomWrapper__bottom__leftContent flex-1"
              style="gap: 12px"
            >
              <!-- TypePublic -->
              <WrapperDropdown
                v-if="item.typesPublicsAvecPlusieursPotentiel"
                label="Type de public"
                :model-value="item.typesPublicsDropdownValue"
                @update:model-value="item.typesPublicsDropdownValueUpdate($event as TypePublicDropdownItem)"
                :items="item.typesPublicsDropdownItems"
                :key-id="'id'"
                :key-label="'label'"
                :readonly="isReadOnly"
                :deletable="false"
              ></WrapperDropdown>

              <!-- Admin -->
              <WrapperDropdown
                :label="`Administrateur ${item.estProprietaireHabilitation ? '(non modifiable)' : ''}`"
                :items="NiveauxPermissionOuiNonItems"
                :model-value="item.permissionAdministrateur.niveau"
                @update:model-value="item.permissionAdministrateur.switchPermission"
                :readonly="isReadOnly"
                :disabled="item.estProprietaireHabilitation"
                :deletable="false"
              ></WrapperDropdown>
            </div>
          </div>
          <BasicButton
            v-if="!isReadOnly"
            label="Supprimer"
            :disabled="item.estProprietaireHabilitation"
            icon-name="trash"
            @click="item.deleteHabilitation"
          ></BasicButton>
        </div>
      </div>
      <div
        class="card__content card__content--mobile card__content--footer"
        v-if="item.type === 'habilitation'"
      >
        <BasicButton
          :icon-name="drawerId === index ? 'arrow-up' : 'arrow-down'"
          :icon-right="true"
          :label="drawerId === index ? 'Fermer' : isReadOnly ? 'Voir' : 'Modifier'"
          @click="toggleDrawer(index)"
        />
      </div>
    </div>
  </div>

  <!-- POPUP Habilitation -->
  <ModalComponent
    v-bind:model-value="isNotNullOrUndefined(showPermissionItem)"
    @update:model-value="showPermissionItem = undefined"
  >
    <template #header>Permissions</template>
    <template #content>
      <div class="modalContent">
        <span>Ce compte possède les permissions suivantes :</span>
        <div class="elem">
          <div class="elem__line">
            <BasicIcon name="edit" />
            <span>Modification</span>
          </div>
          <template v-if="showPermissionItem?.permissionsEcriture?.length ?? 0 > 0">
            <div
              v-for="typePermission in showPermissionItem!.permissionsEcriture"
              class="elem__line"
              :key="typePermission"
            >
              <span class="elem__line__thin">{{ TypePermissionLibelle[typePermission] }}</span>
              <span v-if="typePermission !== TypePermissionLibelle[typePermission]">({{ typePermission }})</span>
            </div>
          </template>
          <template v-else>Aucune</template>
        </div>
        <div class="elem">
          <div class="elem__line">
            <BasicIcon name="eye" />
            <span>Consultation</span>
          </div>
          <template v-if="showPermissionItem?.permissionsLecture?.length ?? 0 > 0">
            <div
              v-for="typePermission in showPermissionItem!.permissionsLecture"
              class="elem__line"
              :key="typePermission"
            >
              <span class="elem__line__thin">{{ TypePermissionLibelle[typePermission] }}</span>
              <span v-if="typePermission !== TypePermissionLibelle[typePermission]">({{ typePermission }})</span>
            </div>
          </template>
          <template v-else>Aucune</template>
        </div>
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { type HabilitationsAdminEmits } from './HabilitationsAdmin.type'
  import { objectToDropdownItems } from '@/features/interface/shared/tools'
  import { NiveauPermission, NiveauPermissionLibelle, TypePermissionLibelle } from '@/features/domaine/types/opco'
  import { storeToRefs } from 'pinia'
  import { useHabilitationsAdminContentStore } from './useHabilitationsAdminContentStore'
  import { type HabilitationViewItem } from './useHabilitationsAdminContentHabilitationsProvider.ts'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
  import { isNotNullOrUndefined } from '@/features/shared/tools'
  import { useSimplePagination } from '@/features/interface/composables/useSimplePagination.ts'
  import {
    useHabilitationsAdminContentHabilitationsProvider,
    type TypePublicDropdownItem,
  } from '@/features/interface/profil-utilisateur/sections/admin/useHabilitationsAdminContentHabilitationsProvider.ts'

  const NiveauxPermissionItems = objectToDropdownItems(NiveauPermissionLibelle).filter((item) => item.id !== 'NC')
  const NiveauxPermissionOuiNonItems: { id: NiveauPermission; label: string }[] = [
    { id: 'Ecriture', label: 'Oui' },
    { id: 'Aucun', label: 'Non' },
  ] as const

  const storeContent = useHabilitationsAdminContentStore()
  const { engineState, isReadOnly } = storeToRefs(storeContent)

  const { habilitations } = useHabilitationsAdminContentHabilitationsProvider({
    emitAutorisationsChanged: (reason, habilitation) => emits('autorisationsChanged', reason, habilitation),
  })

  const { pagesNumber, pagesCount, pageData } = useSimplePagination(habilitations, 10)

  const desktopColumnSizeClass = computed(() => {
    const estEntiteEtContactVisible =
      engineState.value.type === 'administrateur' && engineState.value.mode !== 'contact'

    if (estEntiteEtContactVisible)
      return {
        compte: 'elem--span-16',
        permission: 'elem--span-9',
        typePublic: 'elem--span-4',
        admin: 'elem--span-3',
        action: 'elem--span-4',
        validationSeparateur: 'elem--span-12',
        validationAction: 'elem--span-4',
        messageAttente: 'elem--span-20',
      }
    else
      return {
        compte: 'elem--span-8',
        permission: 'elem--span-17',
        typePublic: 'elem--span-4',
        admin: 'elem--span-3',
        action: 'elem--span-4',
        validationSeparateur: 'elem--span-20',
        validationAction: 'elem--span-4',
        messageAttente: 'elem--span-28',
      }
  })

  const emits = defineEmits<Pick<HabilitationsAdminEmits, 'autorisationsChanged'>>()

  const showPermissionItem = ref<HabilitationViewItem>()

  /* Panneau de modification */
  const drawerId = ref<number | null>(null)
  const toggleDrawer = (id: number) => {
    if (drawerId.value === id) {
      drawerId.value = null
    } else {
      drawerId.value = id
    }
  }

  // Ferme le panneau sur changement de numéro de page
  watch(pagesNumber, () => (drawerId.value = null))

  // Ferme le panneau sur la suppression ou l'ajout
  watch(
    () => habilitations.value?.length,
    () => (drawerId.value = null),
  )

  /* Repositionnement pagination */
  // Positionnement pagination sur ajout Habilitation
  watch(
    () => habilitations.value?.length,
    (newLength, oldLength) => {
      if (!oldLength) return
      // Traite ajout
      if (oldLength + 1 === newLength) {
        pagesNumber.value = pagesCount.value
      }
    },
  )

  // Positionnement pagination sur suppression Habilitation
  watch(pagesCount, (newValue, oldValue) => {
    if (newValue === oldValue + 1) return
    if (newValue === oldValue - 1 && pagesNumber.value === oldValue) {
      // Traitre supression sur derniére page
      pagesNumber.value = newValue
    } else if (newValue === oldValue - 1 && pagesNumber.value !== oldValue) {
      // Traitre supression sur autre page : Ne fait rien
    } else {
      // Traitre Reset
      const existHabilitation = habilitations.value?.length ?? 0 > 0
      pagesNumber.value = existHabilitation ? 1 : 0
    }
  })
</script>
<style lang="less" scoped>
  @import '../index.less';

  .link :deep(.text) {
    font-weight: bolder;
  }

  .sous-titre {
    font-size: 10px;
    font-weight: bold;
  }
</style>
